// Prompt AD (2026-09-21) — Well Construction "COMPLETION": Date Completed /
// Completed By, auto-registrados por el backend al pasar a status=completed
// (jobs.py update_job), solo lectura aquí.
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle2 } from 'lucide-react';

export default function CompletionCard({ job }) {
  if (!job.completed_at) {
    return (
      <Card className="bg-white border-gray-100 shadow-sm" data-testid="completion-card">
        <CardContent className="p-3">
          <p className="text-xs text-gray-400 italic" data-testid="completion-empty">Not completed yet.</p>
        </CardContent>
      </Card>
    );
  }
  return (
    <Card className="bg-white border-gray-100 shadow-sm" data-testid="completion-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold font-['Barlow'] flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" /> Completion
        </CardTitle>
      </CardHeader>
      <CardContent className="flex items-center gap-6 text-sm">
        <div>
          <p className="text-[10px] uppercase text-gray-400 font-semibold">Date Completed</p>
          <p className="text-gray-800 font-medium" data-testid="completion-date">{(job.completed_at || '').slice(0, 10)}</p>
        </div>
        <div>
          <p className="text-[10px] uppercase text-gray-400 font-semibold">Completed By</p>
          <p className="text-gray-800 font-medium" data-testid="completion-by">{job.completed_by || '—'}</p>
        </div>
      </CardContent>
    </Card>
  );
}
